export { createWidget } from "./widget";
export type { BitPalmAgentOptions, BitPalmAgentInstance } from "./types";

import { createWidget } from "./widget";

/**
 * Auto-init from script tag:
 * <script src="https://cdn.bitpalm.ae/widget.js" data-slug="my-agent"></script>
 */
if (typeof document !== "undefined") {
  const script = document.currentScript as HTMLScriptElement | null;
  if (script?.dataset.slug) {
    const init = () => {
      createWidget({
        slug: script!.dataset.slug!,
        locale: script!.dataset.locale,
        baseUrl: script!.dataset.baseUrl,
        zIndex: script!.dataset.zIndex ? Number(script!.dataset.zIndex) : undefined,
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  }
}
